import Vue from 'vue'
import App from './App.vue'
import {
  BootstrapVue
} from "bootstrap-vue";
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSmoothScroll from 'vue2-smooth-scroll'
import Vuelidate from 'vuelidate'
import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  faAngleDoubleRight,
  faTimes,
  faStar,
  faSortDown,
  faEquals,
  faCaretRight,
  faChevronRight,
  faHome,
} from '@fortawesome/free-solid-svg-icons'
import VueCardFormat from 'vue-credit-card-validation';
import { faClock ,  faEye} from '@fortawesome/free-regular-svg-icons'

import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import router from './router'

Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);
Vue.use(VueSmoothScroll);
Vue.use(Vuelidate);
Vue.use(VueCardFormat);
library.add(
  faEye, faAngleDoubleRight, faTimes, faStar, faSortDown, faEquals, faCaretRight,faChevronRight, faClock, faHome
)
Vue.component('font-awesome-icon', FontAwesomeIcon)


window.$ = window.jQuery = require('jquery');

Vue.use({
  install: function(Vue){
      Vue.prototype.$jQuery = require('jquery'); // you'll have this.$jQuery anywhere in your vue project
      }
  });
  
  
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
